import { vars } from '../reactive';

export function trackEvent(event: string, properties?: Record<string, any>) {
  if (typeof window === 'undefined') return;
  const branch = vars.currentBranch();
  // // Collar's data layer
  // if (window.dataLayer) {
  //   window.dataLayer.push({
  //     event,
  //     ...properties
  //   });
  // }
  // // Branche's data layer
  // if (window.branch_data_layer) {
  //   window.branch_data_layer.push({
  //     event,
  //     ...properties
  //   });
  // }
  // Google analytics
  if (window.gtag) {
    window.gtag('event', event, { ...properties, send_to: 'G-46RLJ1Q2XV' });
    if (event === AnalyticsEvents.CODE_VERIFIED) {
      window.gtag('config', 'G-46RLJ1Q2XV', {
        user_email: vars.newAccount()?.email
      });
    }
  }
  if (branch?.analytics?.google?.analytics_id) {
    window.gtag('event', event, { ...properties, send_to: branch.analytics.google.analytics_id });
    if (event === AnalyticsEvents.CODE_VERIFIED) {
      window.gtag('config', branch.analytics.google.analytics_id, {
        user_email: vars.newAccount()?.email
      });
    }
  }
  // facebook pixel
  if (window.fbq) {
    window.fbq('track', event, properties);
  }
}

export enum AnalyticsEvents {
  ACCOUNT_CREATED = 'account_created',
  CODE_INPUT = 'code_input',
  CODE_VERIFIED = 'code_verified',
  EMAIL_INPUT = 'email_input',
  FORM_INITIATED = 'form_initiated',
  NAME_INPUT = 'name_input',
  PETS_SELECTED = 'pets_selected',
  PET_CREATED = 'pet_created',
  POSTCODE_INPUT = 'postcode_input',
  FORM_SELECTED = 'form_selected',
  SERVICE_SELECTED = 'service_selected',
  FORM_COMPLETED = 'form_completed',
  DATE_TIME_SELECTED = 'date_time_selected',
  PAYMENT_METHOD_ADDED = 'payment_method_added',
  SERVICE_BOOKED = 'service_booked',
  USER_SUBSCRIBED = 'user_subscribed',
  PREVIOUS_BUTTON = 'previous_button'
}
